module.exports = __webpack_public_path__ + "static/media/Collections-in-villa-experiences-Desktop.49ce9f16.webp";